import createWebStorage from './createWebStorage';

export default createWebStorage('local');


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-persist/es/storage/index.js
// module id = 667
// module chunks = 0